function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "news_icon",
  "data-name": "news icon",
  d: "M1044.687,6040.815a.825.825,0,0,1-.244-.121.837.837,0,0,1-.355-.686c0-.022,0-.043,0-.065a.81.81,0,0,1,.013-.1.031.031,0,0,0,0,0,5.322,5.322,0,0,0,.039-.642,5.182,5.182,0,0,0-9.488-2.909h0c-.013.02-.026.041-.04.06l-.005.007a.832.832,0,0,1-1.091.223.736.736,0,0,1-.106-.073,3.641,3.641,0,0,0-2.036-.621,3.679,3.679,0,0,0-3.672,3.686,3.457,3.457,0,0,0,.019.37.765.765,0,0,1,.012.108c0,.014,0,.028,0,.043a.838.838,0,0,1-.382.7.743.743,0,0,1-.124.067,4.348,4.348,0,0,0,2.1,8.142h13.336a4.348,4.348,0,0,0,2.014-8.19Z",
  transform: "translate(-1025.011 -6033.99)",
  fill: "#ccc"
});

var SvgFooterCloud = function SvgFooterCloud(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.988,
    height: 15.015,
    viewBox: "0 0 21.988 15.015",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFooterCloud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/footer-cloud.87bf8fbb.svg";
export { ForwardRef as ReactComponent };